<template>
  <div class="mobile">
    <div
      id="mainplane"
      class="imgWrapper">
      <!-- <v-btn
        v-for="(h, i) in hotspots"
        :key="`hotspot-${i}`"
        :style="`top: ${h.top}; left: ${h.left}`"
        round
        absolute
        color="rgba(154, 22, 48, 1)"
        dark
        class="button-mobile"
        @click="hotspotClickHandler(h)">
        <div class="button-mobile-content">
          {{ h.name }}
        </div>
      </v-btn>
       -->
      <img
        id="mappa"
        src="static/images/PUCPR_SemTags_2048x2048_ColorCorrection.jpg">
    </div>
    <v-alert
      :value="true"
      type="warning"
    >
      Esta experiência ainda não está disponível neste navegador.
    </v-alert>
    <v-btn
      id="mobile-logo"
    />
    <div id="credit">{{ credit }}</div>
  </div>
</template>

<script>

export default {
  data: () => ({
    credit: 'Imersys Software Ltda.',
    hotspots: [
      {
        name: 'american academy (bloco 4 laranja)',
        top: '58.5%',
        left: '51%',
        videoFile: 'puc360_american_academy.mp4',
        videoVimeoId: '344191085',
        videoYoutubeId: '',
      },
      {
        name: 'biblioteca central',
        top: '68%',
        left: '48%',
        videoFile: 'puc360_biblioteca_central.mp4',
        videoVimeoId: '344191233',
        videoYoutubeId: '',
      },
      {
        name: 'clínica de fisioterapia clínica de educação física',
        top: '63%',
        left: '81%',
        videoFile: 'puc360_clinica_de_fisioterapia.mp4',
        videoVimeoId: '344191541',
        videoYoutubeId: '',
      },
      {
        name: 'clínica de odontologia',
        top: '62%',
        left: '45%',
        videoFile: 'puc360_clinica_de_odontologia.mp4',
        videoVimeoId: '344173690',
        videoYoutubeId: 'TlJ9N4PDUjw',
      },
      {
        name: 'clínica veterinária',
        top: '79%',
        left: '7%',
        videoFile: 'puc360_clinica_veterianria.mp4',
        videoVimeoId: '344173888',
        videoYoutubeId: '',
      },
      {
        name: 'escola de ciênc. da vida (bloco 3 verde)',
        top: '59%',
        left: '40%',
        videoFile: 'puc360_escola_ciencias_da_vida.mp4',
        videoVimeoId: '344174099',
        videoYoutubeId: '',
      },
      {
        name: 'escola de direito (bloco 5 vermelho)',
        top: '61%',
        left: '23%',
        videoFile: 'puc360_escola_de_direito.mp4',
        videoVimeoId: '344180487',
        videoYoutubeId: '',
      },
      {
        name: 'escola de educ. e humanid. (bloco 1 amarelo)',
        top: '68%',
        left: '28%',
        videoFile: 'puc360_escola_de_educacao_humanidades.mp4',
        videoVimeoId: '344180691',
        videoYoutubeId: '',
      },
      {
        name: 'escola de negócios (bloco 4 laranja)',
        top: '59%',
        left: '60%',
        videoFile: 'puc360_escola_de_negocios.mp4',
        videoVimeoId: '344180839',
        videoYoutubeId: '',
      },
      {
        name: 'escola politécnica (bloco 7)',
        top: '54.5%',
        left: '35%',
        videoFile: 'puc360_escola_politecnica_bloco7.mp4',
        videoVimeoId: '344185892',
        videoYoutubeId: '',
      },
      {
        name: 'escola politécnica (bloco 9)',
        top: '55%',
        left: '47%',
        videoFile: 'puc360_escola_politecnica_bloco9.mp4',
        videoVimeoId: '344186194',
        videoYoutubeId: '',
      },
      {
        name: 'fazenda experimental gralha azul',
        top: '69%',
        left: '90%',
        videoFile: 'puc360_fazenda.mp4',
        videoVimeoId: '344186480',
        videoYoutubeId: '',
      },
      {
        name: 'labcom',
        top: '86%',
        left: '76%',
        videoFile: 'puc360_labcom.mp4',
        videoVimeoId: '344187072',
        videoYoutubeId: '',
      },
      {
        name: 'laboratório de modelos',
        top: '71%',
        left: '18%',
        videoFile: 'puc360_laboratorio_de_modelos.mp4',
        videoVimeoId: '344187318',
        videoYoutubeId: '',
      },
      {
        name: 'nucleo de prática jurídica',
        top: '75%',
        left: '26%',
        videoFile: 'puc360_nucleo_de_pratica_juridica.mp4',
        videoVimeoId: '344187522',
        videoYoutubeId: '',
      },
      {
        name: 'Clínica de Nutrição Núcleo de Prática em Psicologia',
        top: '87%',
        left: '10%',
        videoFile: 'puc360_pratica_em_psicologia.mp4',
        videoVimeoId: '344188023',
        videoYoutubeId: '',
      },
      {
        name: 'centro de simulação clínica',
        top: '90%',
        left: '23%',
        videoFile: 'puc360_simulacao_clinica.mp4',
        videoVimeoId: '344188156',
        videoYoutubeId: '',
      },
      {
        name: 'tecpuc',
        top: '56%',
        left: '29%',
        videoFile: 'puc360_TECPUC.mp4',
        videoVimeoId: '344188378',
        videoYoutubeId: '',
      },
    ],
    coldspots: [
      {
        name: 'quadra polieseportiva',
        top: '62.5%',
        left: '70%',
      },
      {
        name: 'apple developer academy',
        top: '63%',
        left: '59%',
      },
      {
        name: 'ftd digital arena',
        top: '67%',
        left: '58%',
      },
      {
        name: 'agência puc inovação hotmilk',
        top: '73%',
        left: '41%',
      },
      {
        name: 'puc idiomas',
        top: '76%',
        left: '36%',
      },
      {
        name: 'escola de medicina (bloco 6 vermelho)',
        top: '65%',
        left: '19%',
      },
      {
        name: 'escola de arq. e design (bloco 2 azul)',
        top: '64%',
        left: '30%',
      },
      {
        name: 'escola de com. e artes (bloco 5 vermelho)',
        top: '59%',
        left: '29%',
      },
    ],
    otherMedia: [{
      index: 1,
      name: 'easteregg',
      videoFile: 'puc360_easteregg.mp4',
      videoVimeoId: '343068826',
    }],
  }),
  methods: {
    eastereggClickHandler(video) {
      this.$router.push({ name: 'Video Vimeo', params: { videoid: video.videoVimeoId } });
    },
    hotspotClickHandler(video) {
      this.$router.push({ name: 'Video Vimeo', params: { videoid: video.videoVimeoId } });
    },
  },
};
</script>

<style>
html, body {
  overflow: hidden;
  margin: 0px;
}

.mobile {
  position: relative;
  width: 100%;
  height: 108vh;
  display: block;
}

.imgWrapper {
  width: 100%;
  max-width: 2000px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  transition: 1s transform ease;
  transform-origin: 0 0;
}

.button-mobile {
  padding-bottom: 3px;
  padding-top: 3px;
  min-height: 30px;
  height: inherit;
}

.button-mobile-content {
  white-space: normal;
  max-width: 120px;
  font-size: .7rem;
}

#mappa {
  height: 108vh;
}

#mobile-logo {
  background-color: transparent;
  background-image: url("/static/images/logo_PUCPR_60anos.png");
  background-size: contain;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
  min-width: 300px;
  min-height: 300px;
  top: -30px;
  border: none;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
  box-shadow: 0px 0px 0px 0px rgba(255,255,255,1);
  z-index: 3;
}

.button-main {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 0;
  top: 0;
  margin: 50px;
  z-index: 3;
}

#credit {
  font-family: 'Helvetica', 'Arial', sans-serif;
  font-size: 0.7em;
  bottom: 9%;
  left: 2%;
  position: absolute;
  color:white;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileFallback.vue